import axios from 'axios';
window.axios = axios;

global.$=global.jQuery=require('jquery');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
